import cx from 'classnames';
import React from 'react';
import { Icon, IconColor, IconSize } from '../../../../icon';
import styles from './icon-column.module.scss';
export const IconColumn = React.memo(({ data, colDef }) => {
    const fieldValues = data[(colDef === null || colDef === void 0 ? void 0 : colDef.field) || 'icon'];
    const iconColumn = {
        ...fieldValues,
    };
    if (!iconColumn.icon.id) {
        return null;
    }
    return (React.createElement("div", { className: styles.iconColumnContainer, "data-tooltip-content": iconColumn.toolTip, "data-testid": "icon-column-testid" },
        React.createElement(Icon, { className: cx(styles.icon, {
                [`${iconColumn.icon.className}`]: iconColumn.icon
                    .className,
            }), id: iconColumn.icon.id, color: iconColumn.icon.color || IconColor.TEXT_COLOR, size: iconColumn.icon.size || IconSize.MEDIUM })));
});
//# sourceMappingURL=icon-column.js.map